import { css } from 'styled-components';

/**
 * Shared styling for react-slick prev/next arrows, used by every slick slider so
 * they look and centre identically (the map card strip and the Latest News strip).
 *
 * Why a border-box chevron instead of a '‹'/'›' text glyph: those glyphs have
 * uneven side-bearings, so even with flex centring they sit visibly off-centre.
 * A chevron drawn from two 2px borders is a plain geometric shape - flex centres
 * its bounding box predictably, on any zoom, with no font dependency. No slick
 * theme CSS is loaded in this app, so these rules fully define the arrows.
 *
 * Colours are themeable via CSS custom properties so a slider over a dark map can
 * use a light button while one on a light section can match:
 *   --arrow-bg   button fill      (default white)
 *   --arrow-fg   chevron colour   (default dark)
 */
export const sliderArrowStyles = css`
  .slick-prev,
  .slick-next {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 5;
    width: 34px;
    height: 34px;
    padding: 0;
    border: none;
    border-radius: 50%;
    background: var(--arrow-bg, #ffffff);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    cursor: pointer;
    font-size: 0; /* hides react-slick's "Previous"/"Next" button text */
  }

  .slick-prev {
    left: 8px;
  }
  .slick-next {
    right: 8px;
  }

  /* Chevron as a centred SVG background. Absolutely centred inside the button so
     it does NOT depend on the button's display - react-slick sets an inline
     style="display:block" on the arrows, which would defeat flex centring. The
     glyph is centred in its own viewBox, so it lands dead-centre in the circle. */
  .slick-prev::before,
  .slick-next::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 14px;
    height: 14px;
    transform: translate(-50%, -50%);
    background: center / 14px 14px no-repeat;
  }
  .slick-prev::before {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23333333' stroke-width='2.6' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M15 6l-6 6 6 6'/%3E%3C/svg%3E");
  }
  .slick-next::before {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23333333' stroke-width='2.6' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M9 6l6 6-6 6'/%3E%3C/svg%3E");
  }

  .slick-prev.slick-disabled,
  .slick-next.slick-disabled {
    opacity: 0.3;
    cursor: default;
  }
`;
